// extracted by mini-css-extract-plugin
export default {"AlertContainer":"Alert_AlertContainer__gvw8A","ModalHeader":"Alert_ModalHeader__o6DeI","ModalTitle":"Alert_ModalTitle__ik7OL","ModalBody":"Alert_ModalBody__vPDmu"};